import { NavigationExtras } from '@angular/router';
import { ITableColumn } from '../table/models/table-column';

export function getDynamicRouteLink(link: string, params: object): string {
    const segments = link.split('/');
    let routerLink = link;

    segments
        .filter((segment) => !!segment)
        .forEach((segment) => {
            if (segment.indexOf(':') === 0) {
                const key = segment.substring(1);
                if (params && params[key]) {
                    routerLink = routerLink.replace(segment, params[key]);
                } else {
                    console.warn(
                        `No truthy value was found using key "${key}" (building link "${link}")`
                    );
                }
            }
        });

    return routerLink;
}

export function getDynamicRouterLink(link: string[], params: object): string[] {
    const routerLink = link;

    routerLink.forEach((segment, index) => {
        if (segment.indexOf(':') >= 0) {
            const key = segment.substring(segment.indexOf(':') + 1);
            if (params && params[key]) {
                routerLink[index] = segment.slice(0, segment.indexOf(':')) + params[key];
            } else {
                console.warn(
                    `No truthy value was found using key "${key}" (building link "${link}")`
                );
            }
        }
    });
    return routerLink;
}

export function getTableCellLinkAndExtras(
    row: any,
    column: ITableColumn
): { link: string; extras: NavigationExtras } {
    if (!row[column.key] || !column.link) {
        return null;
    }

    const link = getDynamicRouteLink(column.link, row);

    const extras: NavigationExtras = { queryParams: {} };

    if (column.queryParamFields) {
        column.queryParamFields.forEach((field) => {
            extras.queryParams[field] = row[field];
        });
    }

    return { link, extras };
}

/**
 * @param {boolean} options.relative Set to `true` to avoid adding a leading slash.
 * Defaults to `false`, meaning that a leading slash will be added to the resulting url.
 * NOTE: If the `routerLink` was absolute to begin with, the resulting url will be absolute even if
 * this is set to `true`.
 * @example
 * getUrlFromRouterLink(['foo', 'bar']); // returns `/foo/bar`.
 * getUrlFromRouterLink(['/', 'foo', 'bar'], { relative: true }); // returns `/foo/bar`.
 * getUrlFromRouterLink(['foo', 'bar'], { relative: true }); // returns `foo/bar`.
 */
export function getUrlFromRouterLink(
    routerLink: string[],
    options?: { relative: boolean }
): string {
    const { relative = false } = options || {};
    const isAbsolute = !relative || routerLink[0] === '/';
    const relativeUrl = routerLink.filter((segment) => !!segment && segment !== '/').join('/');
    if (isAbsolute) {
        return `/${relativeUrl}`;
    }
    return relativeUrl;
}

export function getDeepestFirstChild<TreeType extends { firstChild: TreeType | null }>(
    route: TreeType
): TreeType {
    let deepestChild = route;
    while (deepestChild.firstChild) {
        deepestChild = deepestChild.firstChild;
    }
    return deepestChild;
}
